<div class="bw-dialog detail-dialog">

    <lib-page-header [title]="userData.type + ': ' + userData.key" backTo="">
        <mat-icon icon>visibility</mat-icon>
        <span subtitle *ngIf="userData.label">{{ userData.label }}</span>
        <ng-container actions>
            <button mat-icon-button
                    type="button"
                    [matTooltip]="copiedFlash() ? 'Copied!' : 'Copy JSON to clipboard'"
                    aria-label="Copy JSON to clipboard"
                    [disabled]="!jsonData"
                    (click)="copyJson()">
                <mat-icon>{{ copiedFlash() ? 'check' : 'content_copy' }}</mat-icon>
            </button>
        </ng-container>
    </lib-page-header>

    <div class="bw-body">

        <div class="meta-strip app-panel">
            <div class="meta-row">
                <span class="meta-label">Resource</span>
                <span class="meta-value">{{ userData.resource ? 'Yes' : 'No' }}</span>
            </div>
            <div class="meta-row">
                <span class="meta-label">Created</span>
                <span class="meta-value">{{ userData.createTimestamp | date:'medium' }}</span>
            </div>
            <div class="meta-row">
                <span class="meta-label">Updated</span>
                <span class="meta-value">{{ userData.lastUpdateTimestamp | date:'medium' }}</span>
            </div>
        </div>

        <!-- Payload card. Same .app-panel chrome as the meta-strip card,
             matching the omnibar / table-wrapper pattern of the standard
             list pages. The audit-trail snapshot-section chrome lives
             INSIDE this card so the JSON viewer header + scrollable body
             are visually grouped. -->
        <div class="payload-section app-panel">
            <div class="snapshot-body">
                <div class="snapshot-label">
                    <mat-icon class="snap-icon">data_object</mat-icon>
                    Payload
                </div>
                <div class="snapshot-content">
                    <app-json-path-viewer *ngIf="jsonData; else noPayload"
                                           [value]="jsonData"></app-json-path-viewer>
                    <ng-template #noPayload>
                        <div class="empty">No JSON payload on this row.</div>
                    </ng-template>
                </div>
            </div>
        </div>

    </div>
</div>
